module.exports = __webpack_public_path__ + "static/media/filter.7bb019dc.svg";